import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';

const PublicRoute = ({ children }) => {
  const { isAuthenticated, isAdmin, loading } = useAuth();

  // Mostrar loading enquanto verifica a autenticação
  if (loading) {
    return;
  }

  // Se o usuário estiver logado, redirecionar para a dashboard apropriada
  if (isAuthenticated) {
    // Se for admin, redirecionar para painel admin
    if (isAdmin()) {
      return <Navigate to="/admin" replace />;
    }
    // Se for usuário comum, redirecionar para dashboard
    return <Navigate to="/dashboard" replace />;
  }

  // Se não estiver logado, renderizar a página de login
  return children;
};

export default PublicRoute;

